import React, { useMemo } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { pluralize } from '../../../lib/helpers/text.helpers';
import { pluralTerm } from '../../../lib/helpers/term.helper';
import { useCompanySportTerminology } from '../../../lib/stores/company.store';
import { SportTerminology } from '../../../lib/types';
import { getMessages } from '../report.messages';

interface IConcludedHiddenNoticeProps {
  count: number;
  onShowConcluded: () => void;
}

// Says when "Show Concluded" is hiding rows a filter or search matched, so an empty list isn't mistaken for no matches.
export const ConcludedHiddenNotice: React.FC<IConcludedHiddenNoticeProps> = ({ count, onShowConcluded }) => {
  const termLookup = useCompanySportTerminology();
  const messages = useMemo(() => getMessages(termLookup), [termLookup]);
  const athleteTerm = termLookup[SportTerminology.ATHLETE].toLowerCase();

  return (
    <Box display="flex" alignItems="center" mb={1} style={{ gap: '8px' }}>
      <Typography variant="body2">
        <IntlMsg
          {...messages.lblConcludedHidden}
          values={{ count, athletes: pluralize(count, athleteTerm, pluralTerm(athleteTerm)), verb: pluralize(count, 'is', 'are') }}
        />
      </Typography>
      <Button size="small" color="primary" onClick={onShowConcluded}>
        <IntlMsg {...messages.btnShowConcluded} />
      </Button>
    </Box>
  );
};
